<template>
	<div class="spinner" role="status">
		<div v-for="n in 12" :key="n" aria-hidden="true" />

		<span class="screen-reader-text">Loading jobs…</span>
	</div>
</template>
